module.exports = __webpack_public_path__ + "static/02-421c85a9a03d5259fd71ce8901aad965.jpg";